import React, { memo } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import { WebsiteField } from '../WebsiteField';

const TradeShowTextInputComponent = ({ field, error = false, onTextChange, label, name }) => {
  const className = classNames('form-control', {
    'dirty-field': field.value !== field.origin,
  });

  const input = () => {
    if (label === 'Description') {
      return (
        <textarea
          className={className}
          id={name}
          name={name}
          onChange={event => {
            onTextChange(event, name);
          }}
          placeholder={label}
          value={field.value}
        />
      );
    }

    if (label === 'Website') {
      return (
        <WebsiteField
          className={className}
          name={name}
          onTextChange={onTextChange}
          placeholder={label}
          value={field.value}
        />
      );
    }

    return (
      <input
        className={className}
        id={name}
        name={name}
        onChange={event => {
          onTextChange(event, name);
        }}
        placeholder={label}
        type="text"
        value={field.value}
      />
    );
  };

  return (
    <div className={classNames('form-group', { 'has-error': error })}>
      <label className="field-label" htmlFor={name}>
        {label}
      </label>
      {input()}
    </div>
  );
};

TradeShowTextInputComponent.propTypes = {
  error: PropTypes.bool,
  field: PropTypes.instanceOf(Object).isRequired,
  label: PropTypes.string,
  name: PropTypes.string,
  onTextChange: PropTypes.func,
};

/** Trade show text input component. */
export const TradeShowTextInput = memo(TradeShowTextInputComponent);
